export const French = {
  containerId: 'Foresight_1_1.0.0',
  processId: 'src.main.resources.foresight',
  projectName: "WebQ",
  userLoginError: "Provided credentials are invalid, please try with valid user name and/or password.",
  userNameRequired: "Username can't be blank.",
  otpRequired: "OTP can't be blank.",
  subcategoryNameRequired: "Subcategory Name can't be blank.",
  categoryNameRequired: "Category Name can't be blank.",
  timeRequired: "Time can't be blank.",
  categoryNamesRequired: "Please select Category Name.",
  incidentTypeRequired: "Please Select Incident Type.",
  statusRemarkRequired: "Please select Status Remark.",
  validUserNameRequired: "Please enter valid Email.",
  validUserNameEmailRequired: "Please enter valid Username.",
  passwordRequired: "Password can't be blank.",
  startDateRequired: "Start Date can't be blank.",
  endDateRequired: "End Date can't be blank.",
  rmNameRequired: "Resolution Method Name can't be blank.",
  commentsRequired: "Comments can't be blank.",
  categotyNameRequired: "Please Select Category.",
  subCateNameRequired: "Please Select Subcategory.",
  sourceNameRequired: "Please Select Source.",
  impactNameRequired: "Please Select Impact.",
  assignmentGroupReq: "Please Select Assignment Group.",
  urgencyNameRequired: "Please Select Urgency.",
  locationNameRequired: "Please Select Location Name.",
  priorityRequired: "Please Select Priority.",
  severityRequired: "Please Select Severity.",
  statusRequired: "Please Select Status.",
  assignToRequired: "Please Select Assign To.",
  publishForRequired: "Please Select Publish For.",
  alertCategoryRequired: "Alert Category can't be blank.",
  typeOfTicketRequired: "Please Select Type of Ticket.",
  titleRequired: "Title can't be blank.",
  templateNameRequired: "Template Name can't be blank.",
  loginPendingMessge: "Please wait we are validating...",
  projectNameRequired: "Please select valid Project Name.",
  projectNamePagetext: "Project Name",
  selectProjectOptionText: "Select Project",
  selectProjectAllOptionText: "Select All Project",
  submitButtonText: "Submit",
  cancelButtonText: "Cancel",
  resetButtonText: "Reset",
  updateIncidentText: "Update Incident",
  updateProblemText: "Update Problem",
  createIncidentPageText: "Create Incident",
  createProblemPageText: "Create Problem",
  pleaseWaitText: "Please wait, We are working on your request....",
  titleNameText: "Title",
  notificationDetailsText: "Notification Detail",
  customerNameText: "Customer Name",
  sourceOptionText: "Select Source",
  ResBOptionText: "Select Resolved By",
  CBOptionText: "Select Created By",
  groupNameOptionText: "Select Group Name",
  alertObjectNameText: "Alert Object Name",
  locationNameText: "Location Name",
  locationNameOptionText: "Select Location Name",
  priorityText: "Priority",
  priorityOptionText: "Select Priority",
  incidentOptionText: "Select Incident",
  rbOptionText: "Select Resolution SLA Bracket",
  severityText: "Severity",
  severityOptionText: "Select Severity",
  statusOptionText: "Select Status",
  statuOptionText: "Select Active Status",
  assignToText: "Assign To",
  assignToOptionText: "Select Assign To",
  alertCategoryText: "Alert Category",
  typeOfTicketText: "Type Of Ticket",
  typeOfTicketOptionText: "Select Type Of Ticket",
  incedentDescriptionText: "Description",
  slaText: "SLAs",
  viewslaText: "View SLAs",
  viewWorkFlowText: "View Workflow",
  loginText: "Login",
  footerText: "© " + new Date().getFullYear() + " Tata Communications Transformation Services. All Rights Reserved.",
  tataTagLine: "TATA COMMUNICATIONS and TATA are trademarks of Tata Sons Private Limited in certain countries.",
  NeoText: "NEO AUTOMATA is a trademark of Tata Communications Transformation Services in certain countries.",
  logOutConfirmationMessage: "Do You Want to Continue ?",
  logOutButtonText: "Logout",
  globalErrorMessage: "We are facing issue while fetching data.",
  ticketListText: "Incident(s) List",
  PDListText: "Problems Detected List(s)",
  porblemListText: "Problem(s) List",
  porblemDetectionListText: "Problem Detection(s) List",
  myGroupListText: "My Group Incident(s) List",
  myGroupClosedListText: "Closed/Cancelled Incident(s) List",
  myGroupPListText: "My Group Problem(s) List",
  myGroupPClsedListText: "Closed/Cancelled Problem(s) List",
  reactTableNoDataText: "Please wait...",
  ticketNoText: "Ticket No",
  statusText: "Status",
  ticketDateText: "Created Date",
  ticketDateInprogressTime: "Inprogress Date Time",
  TicketOnHoldLogTime: "On Hold Date Time",
  ticketResolvedLogTime: "Resolved Date Time",
  ticketClosedLogTime: "Closed Date Time",
  exportDataText: "Export Data",
  ticketDetailsText: "Ticket Details",
  noResolvedTicketText: "No Resolved Ticket(s) Found...",
  acceptanceFormText: "Acceptance Form",
  acceptedText: "Accepted",
  acceptorRemarkText: "Acceptor's Remark",
  errorPageText: "Error Page",
  ticketSubmitted: "Ticket is submitted successfully. Please click on Ticket List menu to view details.",
  myDashboardText: "My Dashboard",
  typesofTicktesChartText: "Types of Ticktes Chart",
  loadingChartText: "Loading Chart",
  ticketSummaryChartText: "Ticket Summary Chart",
  totalTicketText: "Total Tickets",
  SLAChartText: "SLA Chart",
  rcaText: "RCA",
  rcaRequired: "RCA can't be blank.",
  ticketListMenuText: "Ticket List",
  acceptanceJobText: "Acceptance Job",
  userListText: "User(s) List",
  roleListText: "Role(s) List",
  statusChangeNotificationListText: "Status Change Notification(s) List",
  autoClosureListText: "Auto Closure(s) List",
  incidentModelListText: "Incident Model(s) List",
  groupListText: "Group(s) List",
  deviceListText: "Device List",
  subcategoryListText: "Subcategory(s) List",
  categoryListText: "Category(s) List",
  statusRemarkListText: "Status Remark(s) List",
  slaListText: "Incident SLA(s) List",
  resolutionMethodListText: "Resolution Method(s) List",
  userNameText: "Email(Username)",
  subcategoryNameText: "Subcategory Name",
  categoryNameText: "Caller Ip",
  CalledIdText: "Called Id",
  CallerIdText: "Caller Id",
  rmNameText: "Resolution Method Name",
  deviceNameText: "Device Name",
  emailText: "Email",
  smsText: "SMS",
  smsNumText: "SMS Number",
  firstNameText: "First Name",
  lastNameText: "Last Name",
  passwordText: "Password",
  roleText: "Role",
  actionText: "Options",
  deleteText: "Delete",
  okText: "Ok",
  updateUserText: "Update User",
  updateSubcategoryText: "Update Subcategory",
  updateRoleText: "Update Role",
  updateCategoryText: "Update Categoty",
  updateResolutionMethodText: "Update Resolution Method",
  updateGroupText: "Update Group",
  updateDeviceText: "Update Device",
  contactNumberText: "Contact Number",
  lastNameRequired: "Last Name Can't be blank.",
  roleNameRequired: "Role Name Can't be blank.",
  accessControlRequired: "Access Control Can't be blank.",
  accessControlsRequired: "Please Select Access Control.",
  firstNameRequired: "First Name Can't be blank.",
  emailRequired: "Email Can't be blank.",
  roleRequired: "Role Can't be blank.",
  contactNoRequired: "Contact No Can't be blank.",
  logRequired: "Log Can't be blank.",
  resolvedText: "Resolved",
  statusLowerText: "status",
  updatedTicketDatetext: "Updated Date",
  addUserText: "Add",
  addRoleText: "Add",
  addGroupText: "Add",
  addIncidentModelText: "Add",
  TemplateNameText: "Template Name",
  PublishForText: "Publish For",
  incidentDetailsText: "Incident Creation Details",
  newIncidentModeltext: "Create Template ",
  viewIncidentModeltext: "View Template Details",
  selectTemplateMenuOption: "Select Option",
  addDeviceText: "Add",
  addSubcategoryText: "Add",
  addCategoryText: "Add",
  addResolutionMethodText: "Add",
  addAutoClosureText: "Add",
  addSlaText: 'Add',
  addSlaWorkflowText: "Add",
  addStatusChangeText: "Add",
  downTimeText: "Downtime(In Minutes)",
  deleteConfirmationMessage: "Are you sure you want to delete?",
  clearConfirmationMessage: "Are you sure you want to clear?",
  deleteErrorMessage: "We are facing issue while deleting data.",
  uploadButtonText: "Upload",
  uploadFileLableText: "Upload CSV File",
  fileUploadRequired: "Please select a CSV file to Upload.",
  addUserErrorMessage: "We are facing issue while adding data.",
  updateUserErrorMessage: "We are facing issue while updating data.",
  addUserSuccessMessage: "User has been added successfully.",
  updateUserSuccessMessage: "User has been updated successfully.",
  deleteUserSuccessMessage: "User has been deleted successfully.",
  userManage: "Manage Users",
  groupManage: "Manage Group",
  roleManage: "Manage Role",
  categoryManage: "Manage Category",
  csatManage: "CSAT",
  subcategoryManage: "Manage Sub-Category",
  priorityManage: "Manage Priority",
  settingsManage: "Update Profile",
  problemDetectionManage: "Manage Problem Detection",
  globalUserSuccessMessage: "Your changes has been saved successfully.",
  userTempalateMessage: "Here is the reference CSV file to import data.",
  downloadText: "Click To Download",
  viewUserDetailText: "View User Detail",
  viewIncidentDetailText: "View Test Execution Trend Detail",
  viewProblemDetailText: "View Problem Detail",
  viewTempDetailText: "View Template Detail",
  applyTempDetailText: "Apply Template",
  viewDeviceDetailText: "View Device Detail",
  globalUserErrorMessage: "We are facing issue while working on your request, Please try after some time.",
  startDateText: "Start Date",
  endDateText: "End Date",
  filterButtonText: "Filter",
  saveAndfilterButtonText: "Filter & Save",
  dateFormat: "DD/MM/YYYY",
  pageRefreshTime: "60000",
  startDateShouldBeLessThanEndDate: "Start Date should be less than or equal to the End Date.",
  selectProjectText: "Select Project ",
  filterText: "Filter",
  resetText: "Reset",
  helpText: "Help Page",
  contactBelowText: "If any case Please Contact below",
  contactEmail: "itdc.helpdesk@tatacommunications.com",
  helpContactNumber: "CUG: 501426 , PSTN: +91 20 67111426 EST hours : 8.00 AM – 5.00 PM",
  firstText: "First",
  lastText: "Last",
  rowtext: "Rows",
  ticketUpdatedSuccessfully: "Ticket has been updated successfully.",
  logText: "Log",
  dateFormatFromDB: "YYYY-MM-DD",
  dateFormatFromDBFull: "YYYY-MM-DD hh:mm:ss",
  dateFormatFromDBFullWithAMPM: "YYYY-MM-DD hh:mm:ss",
  dateFormatFromUIFullWithAMPM: "DD/MM/YYYY H:mm:ss",
  pastDay: 7,
  closedText: "Closed",
  noRecordsFoundText: "No Record(s) Found.",
  ticketHistoryText: "Ticket History",
  noHistoryMessageText: "Ticket History Is Empty.",
  noLogMessageText: "Ticket Log Is Empty.",
  exportCsvRoleText: "skyloAdmin,exportAdmin",
  allProjectSelectedText: "All Project Selected",
  allGroupSelectedText: "All Group Selected",
  allPublishGroupSelectedText: "All Publish For Selected",
  allUserSelectedText: "All User Selected",
  allSourceSelectedText: "All Source Selected",
  allResBSelectedText: "All Resolved By Selected",
  allCBSelectedText: "All Created By Selected",
  allPrioritySelectedText: "All Priority Selected",
  allIncidentSelectedText: "All Incidents Selected",
  allRBSelectedText: "All Resolution SLA Bracket Selected",
  allStatusSelectedText: "All Status Selected",
  allRMSelectedText: "All Resolution Method Selected",
  allRTSelectedText: "All Resolution Type Selected",
  allAccessControlSelectedText: "All Access Control Selected",
  allCategorySelectedText: "All Caller Ip Selected",
  allSubCategorySelectedText: "All Sub Category Selected",
  allRoleSelectedText: "All Role Selected",
  noProjectSelectedText: "Select Project",
  noGroupSelectedText: "Select Group",
  noRoleSelectedText: "Select Role",
  noAccessControlSelectedText: "Select Access Control",
  noCategorySelectedText: "Select Caller Ip",
  noResolutionMethodSelectedText: "Select Resolution Method",
  noResolutionTypeSelectedText: "Select Resolution Type",
  noPrioritySelectedText: "Select Priority",
  noSubCategorySelectedText: "Select Sub Category",
  noAssignTogroupSelectedText: "Select Group",
  noPublishAssignTogroupSelectedText: "Select Publish For",
  noAssignToSelectedText: "Select User",
  selectAllText: "Select All",
  selectAllCategoryText: "Select All Username",
  selectAllSubCAtegoryText: "Select All Sub Category",
  selectAllAccessControlText: "Select All Access Control",
  selectAllGroupText: "Select All Groups",
  selectAllPublishGroupText: "Select All Publish For",
  selectAllUserText: "Select All Users",
  selectAllSourceText: "Select All Source",
  selectAllResBText: "Select All Resolved By",
  selectAllCBText: "Select All Created By",
  selectAllPriorityText: "Select All Priority",
  selectAllIncidentidText: "Select All Incident",
  selectAllRBText: "Select All Resolution SLA Bracket",
  selectAllStatusText: "Select All Status",
  selectAllRMText: "Select All Resolution Method",
  selectAllRTText: "Select All Resolution Type",
  selectAllRoleText: "Select All Roles",
  ticketCreationError: "We are facing some issue while creating new ticket, Please try again after some time.",
  raisedByText: "Ticket Raised By",
  prevLogText: "Log Details",
  errorPageTextMessage: "Provided URL does not exist or probably you dont have access to this URL.",
  fillBelowFormText: "OR Fill THE BELOW FORM",
  userPhotoText: "Profile Photo",
  groupNameRequired: "Group Name Can't be blank.",
  groupNamesRequired: "Please Select Group Name.",
  groupEmailRequired: "Group Email Can't be blank.",
  groupRoleRequired: "Group Roles Can't be blank.",
  groupsRoleRequired: "Please Select Group Roles.",
  groupNameText: "Group Name",
  groupEmailText: "Group Email",
  groupRoleText: "Group Roles",
  roleNameText: "Role Name",
  emailsText: "Email(s)",
  mobileNumbersText: "Mobile Number(s)",
  accessControlText: "Access Control",
  updateProfileText: "Update Profile",
  priorityNameText: "Priority Name",
  urgencyNameText: "Urgency",
  impactText: "Impact",
  priorityListText: "Priority(s) List",
  addPriorityText: "Add",
  updatePriorityText: "Update Priority",
  priorityNameRequired: "Priority Name Can't be blank.",
  urgencyRequired: "Please Select Urgency.",
  impactRequired: "Please Select Impact.",
  noImpactSelectedText: "Select Impact",
  noUrgencySelectedText: "Select Urgency",
  noRCASelectedText: "Select RCA",
  naText: "N/A",
  showAdminFilter: false,
  statusRemarkNameText: "Status Remark Name",
  addStatusRemarkText: "Add",
  statusRemarkNameRequired: "Status Remark Name can't be blank.",
  statusRemarkStatusRequired: "Please Select Status.",
  isActiveStatus: "Please Select isActive",
  updateStatusRemarkText: "Update Status Remark",
  NoImageUploaded: "No Image Uploaded.",
  userNameIsDuplicate: "Provided Email/UserName is already exists.",
  categoryNameIsDuplicate: "Provided Category Name is already exists.",
  statusReNameIsDuplicate: "Provided Status Remark Name is already exists.",
  roleNameIsDuplicate: "Provided Role Name is already exists.",
  grpNameIsDuplicate: "Provided Group Name is already exists.",
  grpNameIsDuplicateNew: "Provided Group Name is already exists either as a Group name or Role name.",
  priorityNameIsDuplicate: "Provided Priority Name is already exists.",
  rmNameIsDuplicate: "Provided Resolution Method Name is already exists.",
  subcategoryNameIsDuplicate: "Provided Sub Category Name is already exists.",
  pleaseWaitTextForDuplicateUserName: "Please wait, We are checking for valid UserName.",
  pleaseWaitTextForDuplicateCategoryName: "Please wait, We are checking for valid Category Name.",
  pleaseWaitTextForDuplicateRMName: "Please wait, We are checking for valid Resolution Method Name.",
  IMConfigurationText: "WebQ",
  PMConfigurationText: "Problem",
  CMConfigurationText: "Change",
  KMConfigurationText: "Knowldge",
  UMConfigurationText: "User Management",
  moduleNameText: "Module",
  createIncidentManage: "Create Incident",
  createProblemManage: "Products",
  statusRemarkManage: "Manage Status Remark",
  resolutionMethodManage: "Manage Resolution Method",
  selectStatusText: "Select Status",
  markAsMajorText: "Mark as Major Incident",
  markAsMajorProblemText: "Mark as Major Problem",
  sourceText: "Source",
  sourceContactText: "Source Contact",
  configurationItemText: "Configuration Item",
  assignmentGroupText: "Assignment Group",
  assignmentToText: "Assign To",
  commentsText: "Comments",
  addAttachmentText: "Add attachment",
  attachmentText: "Attachment",
  titlePlaceHolder: "Keep It Short",
  subCatText: "Subcategory",
  catText: "Category",
  incidentModelNameText: "Template Name",
  prioText: "Priority",
  incidentListManage: "Assigned To Me",
  ticketCreatedSucess: "Incident is created successfully.",
  problemCreatedSucess: "Problem is created successfully.",
  IncidentIdText: "Incident ID",
  ProblemIdText: "Problem ID",
  selectText: "Select",
  actionsText: "Actions",
  selfAssignText: "Assign To Me",
  exportText: "Export",
  bulkResloveText: "Bulk Resolve",
  myGroupManage: "My Group",
  titleMaxCharLength: "250",
  contactNoShouldBeNumber: "Please enter numeric characters only.",
  contactNoLength: "Contact Number should be 10 digit long.",
  setAsDefaultConfirmationMessage: "All NEW incidents without a group will be assigned to the selected group by default. Do you want to proceed?",
  welcomeUserText: "Welcome to Foresight T2R",
  assignToMemessageWithResolvedOrHold: "Selected incidents will be changed to 'In Progress' and assigned to you. \n\n Selection includes incidents with status 'On Hold' or 'Resolved'. \n\n Do you want to proceed?",
  assignToMemessageWithOutResolvedOrHold: "Selected incidents will be changed to status 'In Progress' & assigned to you. \n\n Do you want to Proceed?",
  autoClosureTimeText: "Time (In Minutes)",
  autoClosureManage: "Manage Auto-Closure",
  incidentSlaManage: "Manage SLA",
  incidentReportManage: "Manage Reports",
  updateAutoClosureText: "Update AutoClosure",
  statusReText: "Status Remark",
  selectStatusReText: "Select Status Remark",
  resolutionUpdateText: "Resolution Update",
  relatedItemText: "Related Items",
  KnowledgeArticlesText: "Knowledge Articles",
  MajorIncidentText: "Major Incident",
  HistoryText: "Incident History",
  ProblemHistoryText: "Problem History",
  KnownErrorText: "Known Error",
  MajorProblemReviewText: "Major Problem Review",
  ResolutionmethodText: "Resolution Method",
  selectReMeText: "Select Resolution Method",
  ResolutionremarksText: "Resolution Remarks",
  ResolutiontypeText: "Resolution Type",
  resolutionTypeOptionText: "Select Resolution Type",
  AddtoKBText: "Add to KB",
  autoClosureIsDuplicate: "Auto Closure details are already exists with selected Category and Priority.",
  cancelledText: "Cancelled",
  onHoldText: "On Hold",
  pendingText: "Pending",
  resolutionMethodNameRequired: "Please select Resolution Method.",
  resolutionTypeRequired: "Please select Resolution Type.",
  resolutionRemarksRequired: "Resolution Remarks Can't be blank.",
  incidentbulkResloveText: "Incident Bulk Resolution",
  selectedIncidentsText: "Selected Incidents",
  lastUpdatedOnText: "Last Updated On",
  uploadedDocText: "Attached Document(s)",
  downloadFilesText: "Download",
  incidentUpdatedSucess: "Incident is updated successfully.",
  problemUpdatedSucess: "Problem is updated successfully.",
  assignToMeStatuses: 'Resolved,On Hold,In Progress',
  assignToMeProblemStatuses: 'Resolved,Pending,In Progress',
  myGroupStatuses: 'Resolved,On Hold,In Progress,New',
  closedCancelledStatuses: 'Closed,Cancelled',
  myGroupProblemStatuses: 'Resolved,Pending,In Progress,New',
  bulkResolvedErrorMessageOnSelection: "Your selection incident(s) in 'Resolved' status. Resolved incidents cannot be resolved again.",
  failedToUpdateText: " Failed to update.",
  UpdatedSuccText: " Updated successfully.",
  userText: "User",
  changesupdatesText: "Changes/Updates",
  feildText: "Field Name",
  oldValueText: "Old Value",
  NewValueText: "New Value",
  capsLockMessageText: "Your Caps Lock is On.",
  changePasswordText: "Change Password",
  oldPasswordText: "Old Password",
  newPasswordText: "New Password",
  confirmPasswordText: "Confirm Password",
  oldPasswordRequired: "Old Password Can't be blank.",
  newPasswordRequired: "New Password Can't be blank.",
  confirmPasswordRequired: "Confirm Password Can't be blank.",
  updateLinkText: "Update",
  deleteLinkText: "Delete",
  setAsDeLinkText: "Set As Default",
  viewLinkText: "View Details",
  resetPasswordLinkText: "Reset Password",
  resetPassConfirmationMessage: "Are you sure you want to reset password?",
  cloneConfirmationMessage: "A new incident will be created with the details of the current incident.",
  imageNameText: "Attachment Name",
  deleteImageConfirmationMessage: "Are you sure you want to delete attachment?",
  newConfirmPasswordSame: "New and Confirm password should be same.",
  newPasswordNotMatchCriteria: "Password should be 8 digit with at least 1 alphabet, 1 special character and 1 number.",
  invalidOldPassword: "Provided old password is not match with our records.",
  passwordChangeSucess: "Your password has been updated successfully. You will be rediredcted to login page for re-login.",
  forgotpasswordChangeSucess: "Your password has been updated successfully.",
  textAreaMaxLength: "5000",
  slaNameText: "SLA Name",
  slaWorkflowNameText: "Workflow Name",
  slaTypeText: "SLA Type",
  slaTargetText: "Target",
  slaDurationText: "Duration",
  slaActiveText: "Active",
  startConditionText: "Start Condition",
  pauseConditionText: "Pause Condition",
  completeConditionText: "Complete Condition",
  slaStartConditionText: "SLA Start Condition",
  slaPauseConditionText: "SLA Pause Condition",
  slaCompleteConditionText: "SLA Complete Condition",
  addAnotherConditionText: "Add Another Condition",
  isText: "Is",
  addSlaConfigurationText: "Add Start Condition",
  addConfigurationButtonText: "Add Configuration",
  andText: "AND",
  orText: "OR",
  slaTargetText: "SLA Target",
  slaStatusText: "SLA Status",
  slaTargetTimeText: "SLA Target Time",
  slaTimeRemainingText: "SLA Time Remaining",
  slaNameRequired: "Name Can't be blank.",
  slaTypeRequired: "Please Select Type.",
  slaTargetRequired: "Please Select Target.",
  noSlaFound: "No SLA found for this incident id.",
  noSlaFoundModel: "No SLA found for this incident Model.",
  noActiveTemplateFoundModel: "No active template found for your groups.",
  zeroTimeRemainingText: "00:00:00:00",
  slaRunningText: "Running",
  slaSelectionText: "SLA",
  selectSlaTypeText: "Select SLA Type",
  pleaeSelectSlaText: "Please Select SLAs.",
  selectSlaTargetText: "Select SLA Target",
  selectPleaseSlaTargetText: "Please Select SLA Target.",
  selectConditionText: "Select Condition",
  allSelectedText: "All Selected",
  operatorsText: "Select Operator",
  selectConditinRequird: "Please Select Condition.",
  pleaseSelectText: "Please Select",
  pleaseSelectOperatorText: "Please Select Operator.",
  timeInDaysText: "Time In Days",
  timeInHoursText: "Time In Hours",
  timeInMinsText: "Time In Mins",
  timeInSecsText: "Time In Secs",
  updateSlaText: "Update SLA",
  conditionAlredyExist: "Selected Condition already exists in your SLA configuration.",
  conditionAlredyPDExist: "Selected Condition already exists in your configuration.",
  duplicateConditionSelected: "Please check condtions, it alreay exists in your configuration.",
  noDocUploaded: "No Attachment found for this incident id.",
  noDocPUploaded: "No Attachment found for this problem.",
  slaConfigurationText: "SLA Configuration",
  slaWorkflowText: "SLA Workflow",
  BreachedText: "Breached",
  slaCompletedText: "Completed",
  slaWorkflowListText: "Incident SLA(s) Workflow List",
  slaWorkFlowNameText: "Workflow Name",
  slaWorkflowActiveText: "Active",
  escalationRulesText: "Escalation Rules",
  selectSlaForWorkflowText: "Select SLAs for this workflow",
  selectSlaText: "Select SLAs",
  slaElapsedText: "SLA elapsed",
  selecSlaElapsedText: "Select SLA elapsed",
  slaWorkflowNameRequired: "Name Can't be blank.",
  slaElapsedRequired: "Please select SLA Elapsed.",
  smsNumberRequired: "SMS Number Can't be blank.",
  noSMSNumberFound: "No SMS Number Found.",
  smsNumberText: "SMS Number",
  noWorkflowEmailFound: "No Email Found.",
  workflowEmailRequired: "Email Can't be blank.",
  noPauseCondtionText: "No pause conditions.",
  ResolutionSlaPauseCondtionText: "Resolution SLA is paused when Incident status is either 'On Hold' or 'Resolved'.",
  responseText: "Response",
  userNameAndNumber: "UserName Or 10 Digit Number",
  userNameAndGroupAndNumber: "UserName, GroupName And Email",
  addSlaWorkFlowConfigurationText: "Add Condition",
  slaElapsedAlredyExist: "Selected SLA Elapsed already exists in your configuration.",
  invalidNumber: "Please enter a valid mobile number.",
  invalidNumberLength: "Please enter a valid mobile number.",
  updateSlaWorkflowText: "Update SLA Workflow",
  SlaNameDuplicate: "SLA Name is already exists.",
  SlaWorkFlowNameDuplicate: "SLA Workflow Name is already exists.",
  addRelatedItemButtonText: "Add",
  newText: "New",
  inprogressText: "In Progress",
  itemIdText: "Item ID",
  relationTypeText: "Relation Type",
  taggedItemText: "Tag Item",
  noRelatedItemFound: "No Related Item found for this incident id.",
  noRIFound: "No Related Item found.",
  relationTypeSelectText: "Select Relation Type",
  relationTypeRequiredText: "Please Select Relation Type.",
  taggedSelectionText: "Selection",
  selectItemText: "Select Item",
  searchIncidentText: "Search Incident",
  itemRequired: "Item Can't be blank.",
  validItemRequired: "Please select valid Item.",
  noItemSelected: "No Item found.",
  parentIncidentText: "Parent Incident",
  childIncidentText: "Child Incident",
  deleteConfirmationForRelatedItemMessage: "Are you sure you want to de-associate this item from the incident?",
  yesProceedText: "Yes, proceed",
  parentText: "Parent",
  parentAssociationOverrideText: "Your selection will replace an existing parent incident. Do you want to proceed?",
  PagetimeOutInSec: 2000,
  myReportsText: "Reports",
  incidentCountText: "Incidents",
  totalIncidentsText: "Active Incidents",
  statusWiseChart: "Test Execution Trend",
  resolutionSlaChart: "Day Test Ratio",
  greenZoneText: "Not at Risk (SLA Timer<90%)",
  yellowZoneText: "Pass",
  redZoneText: "Fail",
  DayTestRationDetailsText: "View Day Test Ratio Details",
  redText: "red",
  yellowText: "yellow",
  greenText: "green",
  mttrChart: "Month Wise Test Execution Trend",
  mttrText: "MTTR",
  workloadChartText: "Workload Chart",
  NoDataFoundToBuildChart: "No data found to build chart in your selection.",
  mttrIncidentsText: "Resolved Incidents",
  incidentReportText: "Incident Report",
  incidentAnalysisReportText: "Incident Analysis Report",
  createdByText: "Created By",
  resolvedByText: "Resolved By",
  responseSlaBreachText: "Response SLA Breach",
  resolutionSlaBreachText: "Resolution SLA Breach",
  resolutionSLABracketText: "Resolution SLA Bracket",
  searchByIncidentTextsss: "Search by Incident ID",
  searchByIncidentText: "Incident ID",
  selectResponseBreachText: "Select Response SLA Breach",
  selectResolutionBreachText: "Select Resolution SLA Breach",
  selectResolutionSLABracketText: "Select Resolution SLA Bracket",
  selectCreatedByText: "Select Created By",
  selectResolvedByText: "Select Resolved By",
  validIncidentRequired: "Please select valid Incident ID.",
  exportButtonShowText: "Export Link will show here after your filter.",
  noRecordsFoundToexportText: "No Record(s) Found in your filter, Please change your filter criteria.",
  createNewCustomReport: "Custom Report",
  filterSelectinPaneltext: "Filter Selection Panel",
  reportDisplayColText: "Report Display Column Selection Panel",
  availableText: "Available",
  seletcedText: "Selected",
  markAsFavText: "Save as Favourite",
  exportAstext: "Export As",
  submitSurveyText: "Submit Survey",
  thanksSurveyMessage: "Thanks for your feedback.",
  PleaserateText: "Feedback for ",
  surveyAnsRquired: "Please select above options.",
  ratingRequired: "Please select above Rating.",
  exportFeildsRequired: "Please Select feilds to export.",
  exportFeildsCountRequired: "Please select at least 2 columns to continue.",
  customerSatisfactionChartText: "Customer Satisfaction Chart",
  customColCount: 2,
  ratingText: "Rating",
  scoreText: "Score",
  closedIncidentText: "Closed Incidents",
  surevyQuestionText: "How was your experience ?",
  overallScoreText: "Overall Score",
  totalIncidentsResText: "ACTIVE INCIDENTS-RESOLUTION SLA",
  notificationMethodText: "Notification Method",
  notificationMethodOptionText: "Select Notification Method",
  typeOfNotificationsText: "Notification Type",
  statusChangesText: "Status Changes",
  feedbackSurveyText: "Feedback Survey",
  enterEmailIDText: "Email ID",
  enterMobileNumberText: "Mobile Number",
  notificationMethodRequired: "Medium & Recipients Can't be blank.",
  notificationConf: "Configure Notification",
  NotificationsText: "Customer Notifications",
  mediumText: "Medium & Recipients",
  validSMSNumberRequired: "SMS number can't be blank.",
  validMobileNumberRequired: "Please enter a valid mobile number.",
  notificationTypeRequired: "Please Select Notification Type.",
  statusChangeNotificationText: "Manage Status Change Notification",
  incidentTemplateManageText: "Manage Incident Template",
  incidentPDManageText: "Manage Problems Detected",
  updateStatusChangeText: "Update Status Change Notification Configuration",
  updateIncidentModelText: "Update Incident Model",
  TemplateRequired: "Template Can't be blank.",
  UseTemplateText: "Use Template",
  CloneIncidentText: "Clone Incident",
  activeTemplates: "Active Templates",
  emailSmsRequired: "Email Or SMS feilds Can't be blank.",
  IncidentTypeText: "Incident Type",
  IncidentTypeOptionText: "Select Incident Type",
  surveySucessAlertMessage: "Thanks. your feedback has been recorded.",
  imageFormatIsNotValid: "Please select correct image file to upload.",
  invalidCsvfileUploaded: "Please upload valid CSV file.",
  loggedOutWarningMessage: "You will be logged out automatically in ",
  loggedOutWarningMessageNext: " minute. Do you want to extend?",
  YesText: "Yes",
  NoText: "No",
  forgetPasswordText: "Forgot Password?",
  forgetPassText: "Forgot Password",
  forgotPasswordHeaderText: "Please enter your email address or username to reset your password.",
  otpText: "Verify your OTP",
  otpDetailsText: "OTP",
  otpSentText: "An OTP has been sent successfully to your registered mobile number",
  otpSentUpdatedText: "OTP sent successfully.",
  confirmOtpText: "Confirm OTP",
  resendOtpText: "Resend OTP",
  validOtpRequired: "Please enter valid OTP.",
  resetYourPassText: "Reset your password.",
  linkRegenerate: "You can request another OTP in ",
  minutesSeconds: "minutes:seconds",
  thisSessionText: "This session will expire in ",
  SearchplaceHolderForglobal: "Search...",
  globalSearchRequired: "Search text can't be blank.",
  globalSearchpopupText: "Incident Search",
  groupNamesHasReadOnlyGroup: "Your selection includes ReadOnly user group, ReadOnly group can't be assign with any other group(s).",
  resolveErrorMessages: "Your selection includes child incident(s), Please remove child incident(s) to proceed.",
  expandHistoryText: "View History",
  addText: "Add",
  AssociatedIncidentText: "Associated Incident",
  associatedIncidentListRequired: "Please add Related Item.",
  dontHavePermissionToAddItemText: "It seems you dont have permission to add Related Item and hence you are not able to create Problem.",
  itemIdReq: "Item can't be blank.",
  itemIdExist: "Item already exist in your selection.",
  itemIdInValid: "Please select valid Item.",
  deassociateProblemConfMessage: "Are you sure you want to de-associate this item from the Problem?",
  assignToMemessagePWithResolvedOrHold: "Selected problem will be changed to 'In Progress' and assigned to you. \n\n Selection includes incidents with status 'Pending' or 'Resolved'. \n\n Do you want to proceed?",
  assignToMemessagePWithOutResolvedOrHold: "Selected problem will be changed to status 'In Progress' & assigned to you. \n\n Do you want to Proceed?",
  WhatdidwedowellText: "What did we do well",
  WhatcouldhavebeenbetterText: "What could have been better",
  HowtopeventreoccurrenceText: "How to pevent re-occurrence",
  thrdpartydependenciesText: "3rd party dependencies",
  textLimit1000: 1000,
  rcaRequired: "Please select RCA.",
  majorDoWellRequired: "What did we do well can't be blank.",
  majorBeenBetterRequired: "What could have been better can't be blank.",
  majorPreventReoccurrenceRequired: "How to pevent re-occurrence can't be blank.",
  majorDependenciesRequired: "3rd party dependencies can't be blank.",
  Knownerrortitle: "Known Error Title",
  knownerrordescriptionText: "Known Error Description",
  WorkaroundText: "Workaround",
  BroadcastworkaroundText: "Broadcast Workaround",
  SavetoKEDBText: "Save To KEDB",
  attachDelSuccessMessage: "Attachment deleted successfully.",
  itemDelSuccessMessage: "Item deleted successfully.",
  addAttachmentLimitExceed: "Attached file size should be less than or equal to 15 MB.",
  fileSizeLimitLength: 15000000,
  nameText: "Name",
  isActiveText: "Is Active",
  noOfIncidentsText: "No Of Incidents",
  notificationRuleNameReq: "Name can't be blank.",
  noOfIncidentsReq: "No Of Incidents can't be blank.",
  noOfIncidentsInvalid: "No Of Incidents should be numeric.",
  updateProblemDetectionText: "Update Problem Detection Configuration",
  repeatedApicallTimer: 180000,
  clearText: "Clear",
  ProblemdetectedText: "Problem detected: ",
  defalutGrpForText: "Default group for : ",
  moduleSelectRequired: "Please select module.",
  smallYesText: "yes",
  textAreaRows: 3,
  textAreaCols: 50,
  myGroupCloseCancelManage: "Closed/Cancelled Incident List",
  myGroupCloseCancelPManage: "Closed/Cancelled Problem List",
  imageSizeText: "Size",
  clickToUploadtext: "Click here to Upload files",
  SlaBreachMinBracket: 75,
  SlaBreachMaxBracket: 100,
  emailAlreadyExistinSelection: "Provided email already exists in your selection.",
  smsAlreadyExistinSelection: "Provided SMS number already exists in your selection.",
  maxNotificationLimitExceed: "Max limit allowed to add emails is ",
  maxNotificationSMSLimitExceed: "Max limit allowed to add sms number is ",
  placeHolderText: "Enter upto ",
  charatetresText: " character(s).",
  clicktoselectText: "Click to select date.",
  parentInciText: " Parent Incident of",
  ChildInciText: " Child Incident of ",
  ChildText: "Child",
  ParentItext: "Parent",
  charlimitparentChild: 29,
  helpDeskTest: "HELPDESK",
  stringSize: 30,
  stringLargeSize: 100,
  contactNumberPlaceholder: "Please enter 10 digit number.",
  emailPlaceholder: "Please enter email.",
  urgencyImpactRequired: "Please Select Impact And Urgency.",
  profileImageSize: 1000000,
  profileImageSizeExceed: "Profile Photo size exceeded, allowed 1 MB.",
  beingUpdatedByText: "Updating",
  allowedText: " Allowed ",
  mbText: " MB",
  DisconnectionStatusText: "Disconnection Status",
  RTP_CodecText: "RTP Codec",
  RTP_Caller_G107MOSText: "RTP Caller G107MOS",
  RTP_Caller_PacketsCountText: "RTP Caller PacketsCount",
  RTP_Caller_LostPacketsText: "RTP Caller LostPackets",
  RTP_Caller_MaxRfc3550JitterText: "RTP Caller MaxRfc3550Jitter",
  RTP_Caller_PacketTimeText: "RTP Caller PacketTime",
  RTP_Caller_DSCPText: "RTP Caller DSCP",
  RTP_Called_G107MOSText: "RTP Called G107MOS",
  pastYear: 11,
  TCTSServiceAssuranceText: "TCTS Service Assurance",
  TCTSTroubletoResolveText: "TCTS Trouble to Resolve",
  TCTSWorkForceManagementText: "TCTS Work Force Management",
  makeTestCallError: 'Make Testcall Failed',
  helixOrderId: "Helix Ref",
  fieldNumber: "Phone Number",
  reservedNumber: "Reserved Number",
  makeTestCall: "Make Test Call",
  tandcmessage: "I agree to ",
  tandcText: "Terms and Conditions",
  tandcRequired: "Please accept Terms and Conditions.",
  makeaTestCallText: "Voice Line Test",
  testCallListText: "Test call",
  helixOrderIdReq: "Helix Ref can't be blank.",
  fieldNumberReq: "Phone Number can't be blank.",
  validNumberReq: "Please enter valid number.",
  validNumberRequ: "Please enter number starting with 0 or +61 ",
  optusReferenceNumber: "Optus Reference Number",
  DateandTime: "Date and Time",
  TestResult: "Test result",
  Asource: "A Source",
  ASourceIp: "A Source IP",
  BDestination: "B Destination",
  BDestinationIp: "B Destination IP",
  CallDirection: "Call Direction",
  MOS_A: "MOS A",
  MOS_B: "MOS B",
  MOS_Average: "MOS Average",
  Call_Duration: "Call Duration",
  Release_Cause: "Release Cause",
  Release_Location: "Release Location",
  AC_RTPTxCodec: "Voice Codec",
  Total_Packets: "Total Packets",
  Late_Packets: "Late Packets",
  Early_Packets: "Early Packets",
  Overlapping_Packets: "Overlapping Packets",
  Packet_Errors: "Packet Errors",
  Discarded_Packets: "Discarded Packets",
  Average_jitter: "Average Jitter",
  Max_Jitter: "Max Jitter",
  updateMakeACallInterval: 1000,
  downloadPDFFileText: "Download PDF",
  downloadTextFileText: "Download TXT",
  MonitorOngoingCallListText: "Monitor Ongoing Calls",
  OngoingCallsText: "Ongoing Calls",
  sipManageText: "Manage SIP",
  testinginprogresText: "Testing in progress.",
  TestingcompletedsuccessfullyText: "Testing initiated successfully.",
  sipNumberText: "SIP Number",
  reservedByText: "Reserved By",
  defaultIPText: "Default IP",
  defaultPortText: "Default Port",
  sipNumberRequired: "SIP Number can't be blank.",
  reservedByRequired: "Reserved By can't be blank.",
  updateSipText: "Update Sip",
  userActivity: "User Activity Log",
  completedCallText: "Completed Calls",
  runningCallText: "Running Calls",
  refershTimeLimitINSec: 5000,
  recordId: "Record Id",
  username: "Username",
  clientIp: "Client Ip",
  apiUsed: "API Used",
  apiResponse: "API Response",
  remarks: "Remarks",
  recordCreationTime: "Record Creation Time",
  configDetailsText: "Test Evaluation Criteria",
  rtpCallerG107mosRequired: "Config Value cant be blank.",
  rtpCalledG107mosRequired: "MOS B cant be blank.",
  validNumvericNumber: "Please enter valid number.",
  numberinotflimit: "Please enter number in between 1 to 5.",
  configKeyText: "Config Key",
  configValueText: "Config Value",
  redirectingMessage: "Please wait we are redirecting you...",
  selectusernameText: "Select User",
  defaultIPRequired: "Default IP can't be blank.",
  defaultPortRequired: "Default Port can't be blank.",
  PageRoleMappingText: "Page Role Mapping",
  activityDateText: "Activity Date",
  functionality: "Functionality",
  failedText: "fail",
  passedText: "Pass",
  testFailureText: "Fail",
  successText: "success",
  trunkId: "Trunk Id",
  trunkIdStatus: "please select TrunkId",
  trunkIdtext: "Select Trunk Id",
  pleaseWaitPageCount: 19,
  pleaseWaitPopupCount: 15,
  themeText: 'Theme',
  userColorScText: "Choose Color Scheme",
  headerOptiontext: "Header Options",
  restoreDefaultText: "Restore Default",
  sideBarOptiontext: "Sidebar Options",
  CIConfigurationText: "Configuration",

}
